import { ContentPage } from '../page-factory/content-page';
import { packagesPage } from '../pages/page-packages';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  return [
    { title: 'Accommodations - Choose Your Haven - Kumbh Sukrit' },
    {
      name: 'description',
      content:
        'Explore our premium accommodations at Magh Mela 2026. Choose from Sanskriti Vann Kutiram (Mud Houses) and Sanskriti Vann Mandapam (Premium Tents) for your spiritual journey.',
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: 'https://kumbhsukrit.com/accommodations',
    },
  ];
};

export default function AccommodationsIndexPage() {
  return <ContentPage {...packagesPage} />;
}
